import { useLocation, useNavigate } from 'react-router-dom';
import homeImg from '../assets/images/home.png';
import hightlightsImg from '../assets/images/hightlights.png';
import viewsImg from '../assets/images/views.png';
import locationImg from '../assets/images/location.png';
import amenitiesImg from '../assets/images/amenities.png';
import floorplanImg from '../assets/images/floor_plan.png';
import apartmentImg from '../assets/images/inventory.png';
import day_nightImg from '../assets/images/day_night.png';
import '../assets/css/LeftSideBarNav.css';
import locationIcon from '../assets/images/icons/location.png';
import DayNightModeIcon from '../assets/images/icons/DayNightMode.png';
import FloorPlanIcon from '../assets/images/icons/FloorPlan.png';
import AmenitiesIcon from '../assets/images/icons/Amenities.png';
import DroneViewIcon from '../assets/images/icons/DroneView.png';
import HighlightIcon from '../assets/images/icons/Highlight.png';
import HomeIcon from '../assets/images/icons/Home.png';
import InventoryIcon from '../assets/images/icons/Inventory.png';
import VirtualTourBlack from '../assets/images/icons/VirtualTourBlack.png';

// import menuIcon from '../assets/images/icons/Menu.png';

import locationIconWhite from '../assets/images/icons/locationWhite.png';
import DayNightModeIconWhite from '../assets/images/icons/DayNightModeWhite.png';
import FloorPlanIconWhite from '../assets/images/icons/FloorPlanWhite.png';
import AmenitiesIconWhite from '../assets/images/icons/AmenitiesWhite.png';
import DroneViewIconWhite from '../assets/images/icons/DroneViewWhite.png';
import HighlightIconWhite from '../assets/images/icons/HighlightWhite.png';
import HomeIconWhite from '../assets/images/icons/HomeWhite.png';
import InventoryIconWhite from '../assets/images/icons/InventoryWhite.png';
import VirtualTourWhite from '../assets/images/icons/VirtualTourWhite.png';

// import menuIconWhite from '../assets/images/icons/MenuWhite.png';
import Brochure from '../assets/images/icons/brochure.png';
import BrochureBlack from '../assets/images/icons/brochureBlack.png';

import MasterLayoutWhite from '../assets/images/icons/you-master_layout_white.png';
import MasterLayoutBlack from '../assets/images/icons/master_layout_black.png';

import { useEffect, useRef, useState } from 'react';



const LeftSideBarNavElysium = () => {
    const navigate = useNavigate();
    const location = useLocation(); // Get current path
    const [activePath, setActivePath] = useState(localStorage.getItem('activePath') || location.pathname);
    const menuRef = useRef(null);

    useEffect(() => {
        localStorage.setItem('activePath', location.pathname);
        setActivePath(location.pathname);
    }, [location.pathname]);

    useEffect(() => {
        setTimeout(() => {
            const activeElement = document.querySelector(".btn_container.active");
            if (activeElement && menuRef.current) {
                const container = menuRef.current;
                const elementOffset = activeElement.offsetLeft + activeElement.offsetWidth / 2;
                const scrollPosition = elementOffset - container.offsetWidth / 2;
                container.scrollTo({ left: scrollPosition, behavior: "smooth" });
            }
        }, 100);
    }, [activePath]);

    const menuItems = [
        { path: "/elysium-tower/", img: homeImg, alt: "home", icon: HomeIconWhite, iconHover: HomeIcon, text: "Home", id: "home" },
        { path: "/elysium-tower/master-layout/", img: MasterLayoutBlack, alt: "Master Layout", icon: MasterLayoutWhite, iconHover: MasterLayoutBlack, text: "Master Layout", id: "MasterLayout" },
        { path: "/elysium-tower/location/", img: locationImg, alt: "location", icon: locationIconWhite, iconHover: locationIcon, text: "Location", id: "location" },
        { path: "/elysium-tower/amenities/", img: amenitiesImg, alt: "amenities", icon: AmenitiesIconWhite, iconHover: AmenitiesIcon, text: "Amenities", id: "amenities" },
        { path: "/elysium-tower/floorplans/", img: floorplanImg, alt: "floor_plan", icon: FloorPlanIconWhite, iconHover: FloorPlanIcon, text: "Floor Plan", id: "floor_plan" },
        { path: "/elysium-tower/brochure/", img: Brochure, alt: "Brochure", icon: Brochure, iconHover: BrochureBlack, text: "Brochure", id: "Brochure" },
    ];

    const handleMenuClick = (id, path) => {
        navigate(path);
        setTimeout(() => {
            const element = document.getElementById(id);
            if (element && menuRef.current) {
                const container = menuRef.current;
                const elementOffset = element.offsetLeft + element.offsetWidth / 2;
                const scrollPosition = elementOffset - container.offsetWidth / 2;
                container.scrollTo({ left: scrollPosition, behavior: "smooth" });
            }
        }, 100);
    };

    return (
        <div className='sidebar_container elysium_tower'>
            <div className='sideBar_container_grid' ref={menuRef}>
                {menuItems.map((item) => (
                    <div className={`btn_container ${activePath === item.path ? 'active' : ''}`} key={item.path} id={item?.id}>
                        <button key={item.path}
                            type='button'
                            className={`sidebar_btn ${activePath === item.path ? 'active' : ''}`}
                            onClick={(e) => { handleMenuClick(item?.id, item.path); }}
                        >
                            <span>
                                <img src={item.icon} alt={item.alt} className='btn_icon' />
                                <img src={item.iconHover} alt={item.alt} className='btn_icon hover_icon' />
                            </span>
                            <p className='btn_text'>{item.text}</p>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LeftSideBarNavElysium;
